import React, { useState, useEffect } from "react";

const darkColor="#664D03"
const lightColor="#FFF3CD"
// const darkColor="#0A3622"
// const lightColor="#D1E7DD"

export default function HinweisWrapper({ storageKey, defaultOpen = true, children }) {
   // 1. Zustand initialisieren (Zuerst im localStorage nachsehen)
   const [isOpen, setIsOpen] = useState(() => {
      try {
         const savedStatus = localStorage.getItem("Hinweis_" + storageKey);
         // Wenn ein Wert existiert, parsen wir ihn (da localStorage nur Strings speichert)
         return savedStatus !== null ? JSON.parse(savedStatus) : defaultOpen;
      } catch (error) {
         console.error("Fehler beim Lesen aus dem localStorage:", error);
         return defaultOpen;
      }
   });

   // 2. useEffect, um Änderungen im localStorage zu speichern
   useEffect(() => {
      try {
         localStorage.setItem(storageKey, JSON.stringify(isOpen));
      } catch (error) {
         console.error("Fehler beim Speichern im localStorage:", error);
      }
   }, [isOpen, storageKey]);

   // 3. Funktion zum Umschalten
   const toggleOpen = () => setIsOpen((prev) => !prev);

   return (
      <div
      style={{
        position: "relative"
            /* background: "#afa",
            color: "#090",
            border: "solid 1px #090",
            borderRadius: "10px",
            margin: "10px 0",
            overflow: "hidden" */
         }}
      >
         {/* Header / Trigger-Bereich */}
         
         <div
            onClick={toggleOpen}
            style={{
               position: "absolute",
               right: 5,
               top: 5,
               width: 30,
               height: 30,
               background: lightColor,
               color: "#0A3622",
               fontWeight: 900,
               border: "solid 2px "+darkColor+"66",
            //    margin: 4,
               cursor: "pointer",
               borderRadius: "20px",
               userSelect: "none",
               display: "flex",
               justifyContent: "center",
               alignItems: "center",
            }}
         >
            <span>{isOpen ? "x" : "?"}</span>
         </div>

         {/* Bedingtes Rendern der umschlossenen Kinder (children) */}
         {isOpen && (
            <div
               style={{
                  padding: "15px",
                  background: lightColor,
                  color: darkColor,
                  border: "solid 1px "+darkColor+"66",
                  boxShadow: "0 0 16px "+darkColor+"66",
                  borderRadius: "20px",
               }}
            >
               {children}
            </div>
         )}
      </div>
   );
}
